import type { TVisitSummary } from '@/react-query/useVisitSummaries';

type RBLSeverities = {
  green?: number;
  yellow?: number;
  orange?: number;
  red?: number;
};

export type SeverityColor = 'green' | 'yellow' | 'orange' | 'red';

export const SeverityLabels = ['normal', 'mild', 'moderate', 'severe'] as const;
export type SeverityLabel = (typeof SeverityLabels)[number];

export const getSeverityFromColor = (color: SeverityColor | undefined) => {
  if (color === 'green') return 'normal';
  if (color === 'yellow') return 'mild';
  if (color === 'orange') return 'moderate';
  if (color === 'red') return 'severe';
  return undefined;
};

export const getSeverityString = (
  severities?: RBLSeverities,
): SeverityLabel => {
  if (!severities) return 'normal';
  if (severities.red) return 'severe';
  if (severities.orange) return 'moderate';
  if (severities.yellow) return 'mild';
  return 'normal';
};

export const useRblSeverities = (
  visitSummary: TVisitSummary | undefined,
  includeNormal: boolean = false,
) => {
  if (
    !includeNormal &&
    !visitSummary?.quadrants.some(
      (quadrant) =>
        quadrant.rblSeverities?.orange ||
        quadrant.rblSeverities?.red ||
        quadrant.rblSeverities?.yellow,
    )
  )
    return null;

  const quadrantToSortMap = {
    UR: 0,
    UL: 1,
    LL: 2,
    LR: 3,
  };

  const severityStrings = visitSummary?.quadrants
    .sort(
      (a, b) => quadrantToSortMap[a.quadrant] - quadrantToSortMap[b.quadrant],
    )
    .map((quadrant) => getSeverityString(quadrant.rblSeverities));

  return severityStrings;
};
